import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Card, CardTitle, CardText, MenuButton, Button } from "react-md";
import QuickListEdit from "./QuickListEdit";
import ConfirmDialog from "./ConfirmDialog";
import { dateTimeToTime, Capitalize } from "components/Shared/Formatters";
import { getQuickListShareGuid, copyQuickList } from "requests/quickList";
import { DialogContext } from "components/Shared/DialogProvider.tsx";
import WebConfig from "middlewares/WebConfig";
import QuickFilterStatusIcon from "components/QuickLists/QuickFilterStatusIcon.tsx";

class QuickList extends Component {
	static contextType = DialogContext;
  constructor(props) {
    super(props);
    this.onApplyClick = this.onApplyClick.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onShareClick = this.onShareClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.onDeleteClick = this.onDeleteClick.bind(this);
    this.onEditorClick = this.onEditorClick.bind(this);
    this.onRefresh = this.onRefresh.bind(this);
    this.onCopyClick = this.onCopyClick.bind(this);
    this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);

    this.getResult = this.getResult.bind(this);
    this.renderEditor = this.renderEditor.bind(this);
    this.isMobile = this.isMobile.bind(this);
    this.mounted = { current: true };
    this.state = {
      showEditor: false,
      showDeletor: false,
    };
  }

  componentDidMount() { this.onRefresh(); }
  componentWillUnmount() { this.mounted.current = false; }
  isMobile() { return window.innerWidth < 1200; }

  onDeleteClick(e) { e.stopPropagation(); this.setState({ showDeletor: true }); }
  onDeleteConfirmed() { this.setState({ showDeletor: false }); this.props.onDelete(this.props.item); }
  onEditorClick(e) { e.stopPropagation(); this.setState({ showEditor: true }); }
  onCloseClick() { this.setState({ showEditor: false, showDeletor: false }); }
  onRefresh() { this.props.getCount(this.props.item); }
  getResult() { this.props.getResult(this.props.item); }
  onApplyClick(quickList) { this.setState({ showEditor: false }); this.props.onSave(quickList); }
  onMenuClick(e) { e.stopPropagation(); }

  onClick() {
    if (!this.state.showEditor) {
      if (this.props.onClick) {
        this.props.onClick(this.props.item.id);
      }
      else {
        this.onRefresh();
        this.getResult();
      }
    }
  }

  onShareClick(e) {
    e.stopPropagation();
    const { orthosRoot } = WebConfig;

    this.context.showOk("Share Quick List", "Loading quicklist share url...");

    getQuickListShareGuid(this.props.item.id, shareGuid => {
      let url = `${orthosRoot}/webui/get-shared-quick-list?shareGuid=${shareGuid}`;
      const copyUrl = () => navigator.clipboard.writeText(url);
      this.context.showYesNo("Share Quick List", "Press Copy Url to copy the quick list share url", copyUrl, null, "Copy Url", "Cancel");
    }, this.mounted);
  }

  onCopyClick() {
    copyQuickList(this.props.item.id, this.props.onReloadLists, this.mounted);
  }

  renderEditor() {
    const { currentGroupNames } = this.props;

    return (ReactDOM.createPortal(
      <QuickListEdit
        templateList={this.props.templateList}
        {...{ currentGroupNames }}
        id={this.props.item.id}
        item={this.props.item}
        onApply={this.onApplyClick}
        onClose={this.onCloseClick} />,
      document.getElementById("quicklist-container"),
    ));
  }

  render() {
    const { item, isSelected, canEdit, isSharedWithThisUser } = this.props;
    let countDisplay = "...";
    let updateDisplay = "...";
    if (item.count && item.count.asOfDate) {
      updateDisplay = "Updated: " + dateTimeToTime(item.count.asOfDate);
      countDisplay = item.count.recordCount;
    }
    let menuItems = [];
    if (canEdit) {
      menuItems.push(<Button key={1} icon onClick={this.onEditorClick}>edit</Button>);
      if (this.props.canShare) menuItems.push(<Button key={2} icon onClick={this.onShareClick}>share</Button>);
    }

    if (canEdit || isSharedWithThisUser) {
      menuItems.push(<Button key={3} icon onClick={this.onCopyClick}>content_copy</Button>);
      if (item.id > 0) menuItems.push(<Button key={4} icon onClick={this.onDeleteClick}>delete</Button>);
      menuItems.push(<Button key={5} icon onClick={this.onClick}>refresh</Button>);
    }

    return (
      <>
        <Card className={"quicklist text-overflow-hidden nowrap"} style={{ cursor: "pointer" }}>
          <CardTitle className={isSelected ? "selected" : ""} onClick={this.onClick}
            title={<div className="md-card-title--title multiline-ellipsis">{Capitalize(item.name)}</div>}
          />
          <CardText onClick={this.onClick}>
            <div className="md-text-center md-display-2 nomargin quick-list-count font-black">
              <QuickFilterStatusIcon baseQuery={item.templateCode} />
              {countDisplay}
            </div>
            <div className="nomargin md-caption quicklist-footer">
              {updateDisplay}
              {menuItems.length ?
                <MenuButton
                  id="quicklist-menu"
                  className="quicklist-menu-button"
                  onClick={this.onMenuClick}
                  icon
                  closeOnOutsideClick
                  menuItems={menuItems}
                  anchor={{
                    x: MenuButton.HorizontalAnchors.INNER_RIGHT,
                    y: MenuButton.VerticalAnchors.TOP,
                  }}
                >
                  more_vert
                </MenuButton> : null
              }
              {isSelected && !menuItems.length && <div className="md-icon material-icons" >lock</div>}
            </div>
          </CardText>
        </Card>
        {this.state.showEditor && this.renderEditor()}
        {this.state.showDeletor && <ConfirmDialog
          title="Confirm Quick List Delete"
          message={item.name}
          onOkClick={this.onDeleteConfirmed}
          onCancelClick={this.onCloseClick} />}
      </>
    );
  }
}
QuickList.propTypes = {
  templateList: PropTypes.array.isRequired,
  currentGroupNames: PropTypes.array,
  item: PropTypes.object.isRequired,
  getCount: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  canEdit: PropTypes.bool.isRequired,
  canShare: PropTypes.bool.isRequired,
  isSharedWithThisUser: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  getResult: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onReloadLists: PropTypes.func.isRequired,
};

export default QuickList;